import { IVehicle } from "./vehicle.type";

export enum REPOSSESSION_STATUS {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  SUSPENDED = "SUSPENDED",
  CANCELED = "CANCELED",
}
export enum REPOSSESSION_REASON {
  NON_PAYMENT = "NON-PAYMENT",
  OTHER = "OTHER",
}

export type IRepossessionNote = {
  text: string;
  date: Date;
  author: string;
  currentPath: string;
};
export type IRepossession = {
  _id?: string;
  reason: string;
  notes: IRepossessionNote[];
  notesDetails: IRepossessionNote[];
  vehicle: IVehicle;
  collector: ICollector;
  renterId: string;
  renterName: string;
  repossessionStatus: "PENDING" | "COMPLETED" | "SUSPENDED";
  repossessionReason: "NON-PAYMENT" | "OTHER";
  repossessionNotes: string;
  repossessionStartedAt: Date;
  repossessionCompletedAt: Date | null;
  suspended: boolean;
  suspendedNote: string | null;
};

export type IRepossessionReceivables = {
  vehicle: IVehicle;
  city: string;
  vehicleInBase: boolean;
  renterId: string;
  renterName: string;
  renterWhatsapp: string;
};

export type IDebitmanagment = {
  _id?: string;
  companyId: string;
  renter: IRenter;
  daysOverdue: number;
  amount: number;
  status: NegotiationStatus;
  negotiations?: INegotiations[];
  createdAt?: Date;
  updatedAt?: Date;
};

export type IRenter = {
  id?: string;
  name?: string;
  whatsapp?: string;
  cpf?: string;
  licensePlate?: string;
  companyId?: string;
  vehicleId?: string;
  partnerId?: string;
};

export type ICollector = {
  id?: string;
  name?: string;
  whatsapp?: string;
  pixKey?: string;
  pixKeyType?: string;
  payed?: boolean;
};

export enum NegotiationStatus {
  PENDING = "PENDING",
  IN_NEGOTIATION = "IN_NEGOTIATION",
  PAID = "PAID",
  CANCELLED = "CANCELLED",
}

export type INegotiations = {
  _id?: string;
  total: number;
  createdAt: Date;
  updatedAt: Date;
  paymentNegotiations: IPaymentInstallment[];
  callCenterInteractions?: ICallInteraction[];
};

export type IPaymentInstallment = {
  _id?: string;
  description: string;
  individualAmountPayment: number;
  paymentDate: string;
};

export type ICallInteraction = {
  _id?: string;
  interactionId?: string;
  notes?: string;
  contactDate: Date;
  author?: string;
  createdAt?: Date;
  updatedAt?: Date;
};


type DamagedPart = {
  name: string;
  code: string;
  productOrWorkId: string;
  quantity: number;
  sellPrice: number;
};
export interface FormValues {
  damagedParts: DamagedPart[];
  returnReason: string;
  optionRepossesion?: string;
  withoutPhotos?: boolean;
  changeVehicle?: boolean | "";
  observation?: string;
}

export type DamagedPartRow = {
  id: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectedOption: any | null;
  quantity: number;
};
export interface CollectorReprosessionDto {
  _id: string;
  companyId: string;
  name: string;
  email: string;
  whatsapp: string;
  categoryCNH: string;
  cnh: string;
  cpf: string;
  cpfDoIndicador: string;
  maritalStatus: string;
  pendencies: [];
  references: {
    name: string;
    content: string;
    verified: boolean;
    _id: string;
  }[];
  lead_id: string;
  criminalCheck: {
    jus: boolean;
    escavador: boolean;
  };
  externalReferences: {
    chat: {
      lastMessageAt: Date;
      id: string;
      contactId: string;
      isLastMessagefromMe: boolean;
    };
    paymentCustomerId: string;
    trafficFineCustomerId: string;
    velotrackDriverId: string;
    velotrackCode: string;
    octadeskId: string;
  };
  currentPlan: string;
  birthDate: Date;
  documents: {
    type: string;
    content: string;
    verified: boolean;
  }[];
  address: {
    zipcode: string;
    street: string;
    number: string;
    complement: string;
    district: string;
    city: string;
    state: string;
    latitude: number;
    longitude: number;
  };
  gender: string;
  status: string;
  createdAt: Date;
  updatedAt: Date;
  cnhExpirationDate: Date;
  typeSanguine: string;
  rg: string;
  rg_orgexp: string;
  motherName: string;
  contratoPdfIleva: string[];
  rescisaoPdf: string;
  avatar: string;
  booking: {
    depositValue: number;
    typePayment: string;
  };
  observations: [];
  leadOrigin: string;
  technicalConsultant: string;
  sdr: string;
  contract: {
    name: string;
    cpf: string;
    birthDate: string;
    rg: string;
    rg_orgexp: string;
    whatsapp: string;
    email: string;
    zipcode: string;
    street: string;
    number: string;
    district: string;
    city: string;
    state: string;
    complement: string;
    cnh: string;
    licensePlate: string;
    categoryCNH: string;
    customizedPlan: string;
    brand: string;
    model: string;
    year: string;
    odometer: string;
    fuel: string;
    fipeValue: string;
    fipeVehicleCode: string;
    price: string;
    date: string;
    caucao: string;
    months: number;
    devolutionDate: Date;
    days: number;
  };
  planCancellation: [];
  finishedPlan: [];
  additionsService: [];
  cpfDoIndicadorOptions: {
    indicated: boolean;
    notIndicated: boolean;
  };
  situation: string;
  situationDate: Date;
  groupName: string;
  jurValidation: {
    status: boolean;
    validated: boolean;
    details: string;
    timestamp: Date;
  };
  removedPayment: {
    paymentId: string;
    author: string;
    invoiceUrl: string;
    deletionReason: string;
  }[];
  createdInstallments: {
    numberInstallments: 4;
    installmentValue: 117.08;
    parceledAmount: 468.3;
    paymentMethod: string;
    createdAt: Date;
    installmentAuthor: string;
    paymentId: string;
    installmentType: string;
  }[];
  repossessionHistory: {
    vehicleId: string;
    reason: string;
    startedAt: Date;
    completedAt: Date | null;
    notes: string;
  }[];
  freezePlanInfo: [];
  __v: number;
  activationData: {
    vehicle: {
      id: string;
      licensePlate: string;
      document: string;
      brand: string;
      model: string;
      color: string;
      chassi: string;
      fipeCode: string;
      renavam: string;
      yearModel: string;
      deviceId: string;
      motorNumber: string;
      partnerId: string;
      odometerVehicle: number;
      isReserve: boolean;
    };
    plan: {
      id: string;
      label: string;
      rawValue: 59.9;
      value: 468.30000000000007;
      price: string;
      planType: string;
      deposit: number;
      depositInstallments: 8;
      ilevaId: null;
      subscriptionInitialDate: Date;
      subscriptionEndDate: Date;
      additions: {
        label: string;
        value: number;
        key: string;
      }[];
      easyDepositInfo: [];
    };
    activationDate: Date;
    currentContractStartDate: Date;
    type: string;
  };
  desactivationData: {
    vehicleHistory: {
      id: string;
      licensePlate: string;
      document: string;
      brand: string;
      model: string;
      color: string;
      chassi: string;
      fipeCode: string;
      renavam: string;
      yearModel: string;
      deviceId: string;
      motorNumber: string;
      vehicleHistoryInitial: Date;
      vehicleHistoryEnd: Date;
      partnerId: string;
      optionRepossesion: string;
    }[];
    planHistory: [];
  };
  pendingFinancial: [];
  collector: boolean;
  restorePayment: [];
  situationFinancial: string;
  dataPix: {
    keytype: string;
    key: string;
  };
  rating: number;
  proRataCount: number;
  isBlacklisted: boolean;
}
